export type GuestlistTagCount = {
  tag: string;
  count: number;
};

/** How many guestlist people have each tag. A person is counted once per tag. */
export function countGuestlistTags(
  users: ReadonlyArray<{ tags?: readonly string[] | null }>
): GuestlistTagCount[] {
  const counts = new Map<string, number>();

  for (const user of users) {
    const seen = new Set<string>();
    for (const raw of user.tags ?? []) {
      const tag = raw.trim();
      if (!tag || seen.has(tag)) {
        continue;
      }
      seen.add(tag);
      counts.set(tag, (counts.get(tag) ?? 0) + 1);
    }
  }

  return [...counts.entries()]
    .map(([tag, count]) => ({ tag, count }))
    .sort((a, b) => b.count - a.count || a.tag.localeCompare(b.tag));
}
